
import wx from 'weixin-js-sdk';
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: 'factoryBack',
components: {
wx,XTextarea,Group,Popup,PopupHeader,XButton,Radio,
},
directives: {
TransferDom
},
data () {
return {
id:0,
pickerStatus:false,
abnormal_title:'请选择',
code:'',
abnormals:[],
content:'',
abnormal_id:0,
order:{
},
}
},
created(){
this.config();
this.abnormal();
},
mounted(){
},
methods:{
copy(val){
this.$func.copy(val,event);
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ["barCode"],
success: function (res) {
setTimeout(()=>{

that.code = res.resultStr.split(',')[1];
that.getOrder();
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
getOrder(){
let that = this;
if(!this.code){
that.$func.showToast('衣物条码无效');
return ;
}




that.$func.startLoading();
this.$api.barOrder({code:this.code}).then((res)=>{
if(res){
that.order = res.data;
that.$func.endLoading();
}
})
},
abnormal(){
let that = this;
this.$api.abnormal({}).then((res)=>{
if(res){
that.abnormals = res.data;
}
})
},
onChange (value) {
let that = this;
this.abnormal_id = value;
this.abnormals.forEach((item)=>{
if(item.key == this.abnormal_id){
that.abnormal_title = item.value;
return;
}
})
console.log(value);
},
submit(){
let that = this;
if(!this.code){
that.$func.showToast('衣物条码无效');
return ;
}
if(!this.abnormal_id){
that.$func.showToast('请选择异常类型');
return ;
}
this.$func.confirm('确认提交？','提示',()=>{
this.$api.submitAbnormal({code:this.code,abnormal_title:this.abnormal_title,content:that.content}).then((res)=>{
if(res){
that.$func.showToast('操作成功');
setTimeout(()=>{
window.location.reload();
},300);
}
})
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/abnormal.vue